import { Injectable, Injector } from "@angular/core";
import { LocationService } from "@play/cup-page";

@Injectable()
export class LocationNg1Service extends LocationService {
    constructor(private injector: Injector) {
        super();
    }

    /**
     * Updates the participant id on the url if needed.
     *
     * @param id
     */
    public updateContestantParameter(id: number): void {
        if (this.getParticipantFromParameter() === id) {
            return;
        }

        this.ng1Location.search({ contestantId: id });
        this.ng1Location.replace();
    }

    get ng1Location(): angular.ILocationService {
        return this.injector.get("$location");
    }
}
